module.exports = __webpack_public_path__ + "static/img/年度最佳电视.f5f65e04.png";